import React, { useState } from "react";
import { client } from "../../..";
import { WA_SET_OPT_IN } from "../../../Queries/WhatsApp";
import { gqlErrorMessage } from "./waUtils";

const CONSENT_PRESETS = ["Agreed verbally on a call", "Requested WhatsApp contact by email", "Submitted website / referral form", "Asked us to message them on WhatsApp"];
const MIN_NOTE = 5;

/**
 * Record how a contact consented to WhatsApp messages. Consent is per number
 * and stored with who recorded it and why (audit + lead timeline).
 */
const ConsentForm = ({ phone, leadId, onSaved, compact = false }) => {
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const save = async () => {
    if (note.trim().length < MIN_NOTE || saving) return;
    setSaving(true);
    setError(null);
    try {
      const { data } = await client.mutate({ mutation: WA_SET_OPT_IN, variables: { phone, optIn: true, note: note.trim(), leadId: leadId || null } });
      onSaved?.(data.whatsappSetOptIn);
    } catch (err) {
      setError(gqlErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={compact ? "" : "wa-block"} style={compact ? {} : { marginBottom: 0 }}>
      <div className="wa-label">How did this contact agree to WhatsApp messages?</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
        {CONSENT_PRESETS.map((p) => (
          <button type="button" key={p} className="wa-chip" style={{ cursor: "pointer" }} onClick={() => setNote(p)}>{p}</button>
        ))}
      </div>
      <textarea className="wa-textarea" rows={2} value={note} maxLength={500} onChange={(e) => setNote(e.target.value)} placeholder="e.g. Agreed on call with Jane on 3 Nov" />
      <div className="wa-help">Recorded with your name and the time. Only record consent the contact actually gave.</div>
      {error && <div className="wa-alert wa-alert--danger" style={{ marginTop: 8 }}>{error}</div>}
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
        <button type="button" className="wa-btn wa-btn--primary wa-btn--sm" disabled={note.trim().length < MIN_NOTE || saving} onClick={save}>
          {saving ? <i className="fa-solid fa-spinner wa-spin" /> : <i className="fa-solid fa-user-check" />} Record opt-in
        </button>
      </div>
    </div>
  );
};

export default ConsentForm;
